import { combineReducers } from 'redux'
import form from './form'
import payment_details from './payment_details'
import accommodation from './accommodation'
import admin from './admin'

const rootReducer = combineReducers({
  form,
  payment_details,
  accommodation,
  admin
})

export default rootReducer


// WEBPACK FOOTER //
// ./src/event_render/reducers/index.js